<template>
  <div class="table">
    <div class="table-header">
        <div class="table-row">
            <div class="cell sort cell-large center" @click="setSorting('ref')">
              REF
              <BaseIcon v-if="sortingOn == 'ref'" :name="this.isAscending ? 'chevron-up' : 'chevron-down'" class="icon"/>
            </div>
            <div class="cell cell-large center">Type</div>
            <div class="cell cell-large center">Prod. Flow</div>
            <div class="cell cell-large center">Raw Mat.</div>
            <div class="cell cell-big">Description</div>
            <LoadAmountList v-if="hasAmountDropdown" :totalItems="totalItems" @selectedAmount="selectedAmount" />
        </div>
    </div>
    <div class="table-content">
      <div 
        class="table-row" 
        v-bind:class="{'active-line-padding': selectedDevice === device}"
        v-for="(device, index) in this.devices" 
        :key="index"
        @click="selectRow(device)"
      >
          <div class="cell cell-large center">{{device.ref}}</div>
          <div class="cell cell-large center">{{device.type}}</div>
          <div class="cell cell-large center">{{device.flowname}}</div>
          <div v-if="device.type != 'assembly'" class="cell cell-large center">{{device.rawMaterialName}}</div>
          <div v-else class="cell cell-large center">/</div>
          <div class="cell cell-big">{{device.description}}</div>
          <div class="cell" @click.stop="openFullScreen(device.ref)">
            <BaseIcon name="image" class="icon" size="lg" />            
            <div v-if="isImageOpened && device.ref == openedImage" class="fullscreen">
              <div 
                class="imageview"
                v-click-outside="closeFullScreen"
              >
                <button class="btn-close" @click.stop="closeFullScreen">
                  <BaseIcon name="window-close" class="icon" />
                </button>
                <img :src="device.image" alt="">
                <BaseButton type="button" :key="3" color="primary" size="modal-sm" @click.native="openEditInspection(device)">
                  Edit Inspection
                </BaseButton>
                <EditInspectionModal v-if="willUpdateInspection" :selectedItem="selectedDeviceInspection" @closeModal="closeEditInspection"/>
              </div>
            </div>
          </div>
          <div class="cell" @click.stop="openMenu(index)" >
            <BaseIcon name="ellipsis-h" class="icon grey" size="lg" />
          </div>
          <MoreTableActions 
            v-if="isOptionOpen && openOptions == index" 
            :locationMenu="index == 0 ? 'bottom' : 'top'" 
            @deleteRow="deleteRow"
            v-click-outside="closeMenu" 
          />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button";
import MoreTableActions from "@/components/base/MoreTableActions";
import LoadAmountList from "@/components/base/LoadAmountList";
import EditInspectionModal from "@/components/EditInspectionModal";

export default {
  components : {
    BaseIcon,
    BaseButton,
    MoreTableActions,
    LoadAmountList,
    EditInspectionModal
  },
  computed : {},
  props: {
    devices: {
      type: Array
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {
  },
  data() {
    return {
      selectedDevice: null,
      sortingOn: "ref",
      isAscending: true,
      isOptionOpen: false,
      openOptions: '',
      isImageOpened: false,
      openedImage: '',
      willUpdateInspection: false,
      selectedDeviceInspection: null,
    }
  },
  methods: {
    selectedAmount(val) {
      this.$emit("selectedAmount", val);
    },
    selectRow(device) {
      if (this.selectedDevice != device) {
        this.isOptionOpen = false
      }
      this.selectedDevice = device
      this.$emit('selectedRow', device)
    },
    openMenu(index) {
      if (this.openOptions != index) {
        this.isOptionOpen = true
      } else {
        this.isOptionOpen = !this.isOptionOpen
      }
      this.openOptions = index
    },
    closeMenu() {
      this.isOptionOpen = false
      this.openOptions = ''
    },
    deleteRow() { 
      var that = this
      var url, selectedID 
      switch(this.selectedDevice.type) {
        case "single":
          url = this.$endpoint + 'management/devices/part/'
          break;
        case "subpart":
          url = this.$endpoint + 'management/devices/part/'
          break;
        case "assembly":
          url = this.$endpoint + 'management/devices/assembly/'
          break;
      }

      this.$http.delete(url + this.selectedDevice.deviceID)
      .then(response => {
        that.isOptionOpen = false
        that.openOptions = ''
        that.$emit('refresh', true);
      })
      .catch(error => {
        if (error.response.status === 401) {
          this.$store
          .dispatch("logout")
          .then(() => this.$router.push("/login"))
          .catch(err => console.log(err));
        } else {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        }
      })
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true
      } else {
        this.isAscending = !this.isAscending
      }
      this.sortingOn = val

      this.$emit("sorting", {on: this.sortingOn, asc: this.isAscending});
    },
    openFullScreen(ref){
      this.isImageOpened = true
      this.openedImage = ref
    },
    closeFullScreen(){
      this.isImageOpened = false
      this.openedImage = ''
    },
    openEditInspection(device){
      this.willUpdateInspection = true
      this.selectedDeviceInspection = device
    },
    closeEditInspection(needFullClose){
      this.willUpdateInspection = false
      this.selectedDeviceInspection = ''
      if(needFullClose) {
        this.closeFullScreen()
        this.$emit('refresh', true);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../style/base.scss";
  @import "../style/components/tables.scss";
  @import "@/style/components/active.scss";

  .table-header{ 
    .table-row{
      .cell.sort {
        cursor: pointer;
      }
    }
  }

    .fullscreen {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: rgba($color: #000000, $alpha: 0.16);

    display: flex;
    justify-content: center;
    align-items: center;

    .imageview {
      min-height: 74vh;
      min-width: 44vh;
      padding: 24px 40px;
      background-color: white;
      border-radius: 8px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .btn-close {
        position: absolute;
        top: 24px;
        right: 24px;
        width: 32px;
        height: 32px;
  
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
  
        background-color: none;
        border: none;
  
        .icon {
          font-size: 18px;
          color: #D0D0D0;
        }
  
        &:hover {
          background-color: none;
          cursor: pointer;
          .icon {
            font-size: 18px;
            color: #6A6A6A;
          }
        }
      }

      img {
        height: 54vh;
        margin-bottom: 24px;
      }
    }
  }
</style>
